import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { API, api } from "../lib/api";

const FALLBACK = [
  { type: "video", src: "https://customer-assets.emergentagent.com/job_inhoa-at-home/artifacts/fwucmg1n_VID-20260709-WA0019.mp4", h: "md:col-span-2 md:row-span-2 aspect-[4/5] md:aspect-auto", cap: "En vídeo · Dentainhoa" },
  { src: "https://customer-assets.emergentagent.com/job_inhoa-at-home/artifacts/t0atlqle_IMG-20260709-WA0017.webp", h: "aspect-[4/3] md:aspect-auto", cap: "Recepción" },
  { src: "https://customer-assets.emergentagent.com/job_inhoa-at-home/artifacts/hep6d7c7_IMG-20260709-WA0018.webp", h: "aspect-[4/3] md:aspect-auto", cap: "Sala pediátrica" },
  { type: "video", src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_inhoa-at-home/artifacts/rw179lla_WhatsApp%20Video%202026-08-21%20at%2016.10.16.mp4", h: "aspect-[4/3] md:aspect-auto md:col-span-2", cap: "Limpieza profunda" },
  { src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_inhoa-at-home/artifacts/3sh4j9aq_WhatsApp%20Image%202026-08-21%20at%2016.10.15.jpeg", h: "aspect-[4/3] md:aspect-auto", cap: "Material esterilizado" },
  { type: "video", src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_inhoa-at-home/artifacts/73s1ixni_WhatsApp%20Video%202026-08-21%20at%2016.10.16%20%281%29.mp4", h: "aspect-[4/3] md:aspect-auto md:col-span-2", cap: "Preparación previa" },
];

export default function Gallery() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const r = await api.get("/gallery");
        setItems(r.data);
      } catch {
        setItems([]);
      }
    })();
  }, []);

  // Use API items if any, otherwise fallback
  let list;
  if (items === null) list = FALLBACK; // loading
  else if (items.length === 0) list = FALLBACK;
  else {
    const layouts = ["row-span-2", "", "", "row-span-2", "", ""];
    list = items.map((it, i) => ({
      src: `${API}/gallery/${it.id}/image`,
      cap: it.caption || `Nº ${String(i + 1).padStart(2, "0")}`,
      h: layouts[i % layouts.length],
    }));
  }

  return (
    <section id="trabajo" data-testid="gallery-section" className="py-24 md:py-40">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9 }}
          className="mb-16 text-center"
        >
          <h2 className="font-heading text-4xl md:text-6xl lg:text-7xl tracking-tighter leading-[0.95] max-w-4xl mx-auto">
            Momentos de una <em className="italic text-[color:var(--accent)]">rutina</em> hecha con calma.
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 md:auto-rows-[280px]">
          {list.map((img, i) => (
            <motion.figure
              key={img.src + i}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.9, delay: (i % 3) * 0.08, ease: [0.16, 1, 0.3, 1] }}
              className={`relative overflow-hidden rounded-xl md:rounded-2xl bg-[color:var(--bg-secondary)] ${img.h}`}
              data-testid={`gallery-item-${i}`}
            >
              {img.type === "video" ? (
                <video
                  src={img.src}
                  autoPlay
                  loop
                  muted
                  playsInline
                  preload="auto"
                  className="absolute inset-0 w-full h-full object-contain bg-[color:var(--signature-dark)]"
                />
              ) : (
                <img src={img.src} alt={img.cap} className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] ease-out hover:scale-105" />
              )}<div className="absolute inset-0 bg-gradient-to-t from-[color:var(--signature-dark)]/60 via-transparent to-transparent opacity-70 pointer-events-none" />
              <figcaption className="absolute bottom-3 left-3 right-3 flex items-center justify-between font-mono text-[10px] uppercase tracking-widest text-[color:var(--bg-primary)] pointer-events-none">
                <span>{String(i + 1).padStart(2, "0")}</span>
                <span className="truncate max-w-[70%] text-right">{img.cap}</span>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
